export default __webpack_public_path__ + "static/media/illustrator.ee9cdae4.gif";